<div class="offer-popup" [class.is-mobile]="commonService.isMobileDisableClick">

  <!-- ========== DESKTOP LAYOUT ========== -->
  <ng-container *ngIf="!commonService.isMobileDisableClick">

    <!-- ===== LEFT COLUMN ===== -->
    <div class="offer-left">

      <div class="offer-hero-image">
        <img
          src="assets/imgs/offer_credit.webp"
          alt="Pro Annual Wallet Credits"
          class="wallet-img"
        />
      </div>

      <h2 class="offer-heading">
        Upgrade to <span class="heading-accent">Pro Annual</span>
      </h2>

      <div class="offer-price-row">
        <span class="offer-price">₹1,999</span>
        <span class="offer-price-sub">/ year, billed annually</span>
      </div>

      <p class="offer-desc">
        Sell unlimited beats &amp; sound kits with digital licensing, priority support &amp; lead generation tools — <strong>plus everything below.</strong>
      </p>

      <hr class="offer-divider" />

      <ul class="offer-perks">
        <li>
          <span class="perk-icon"><img src="assets/imgs/wallet.png" alt="Wallet" class="perk-icon-img" /></span>
          <span>
            <strong>Get ₹500 wallet ad credits For Free</strong> by 31st august to promote &amp; boost your
            beats across the platform
          </span>
        </li>
        <li>
          <span class="perk-icon"><img src="assets/imgs/golden-lightning.png" alt="Sound Kits" class="perk-icon-img" /></span>
          <span>
            <strong>Get 600 Sound Kit Credits</strong> — use it to grab sound kits, loops & drum kits from top industry-leading producers.
          </span>
        </li>
      </ul>
    </div>

    <!-- ===== RIGHT COLUMN ===== -->
    <div class="offer-right">
      <button class="close-btn" (click)="close()" aria-label="Close popup">
        <i class="pi pi-times"></i>
      </button>

      <div class="limited-badge">
        <span class="limited-icon">⚡</span>
        LIMITED TIME OFFER - ENDS ON 31ST AUGUST
      </div>

      <h3 class="included-heading">Everything included</h3>

      <div class="wallet-card">
        <div class="wallet-card-icon">
          <img src="assets/imgs/wallet.png" alt="Wallet Credits" class="wallet-card-img" />
        </div>
        <div class="wallet-card-text">
          <p class="wallet-card-title">Get ₹500 Wallet Ad Credits For Free By 31st August</p>
          <p class="wallet-card-sub">Use it to promote &amp; boost your beats across the platform</p>
        </div>
      </div>

      <div class="features-grid">
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Sell Unlimited Beats</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Sell Unlimited Sound Kits</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Digital Licensing</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>10% Commission</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>600 Kits Credits</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Campaigns at 20% Off</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Direct Bank Transfer</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Lead Generation Access</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Priority Support</div>
      </div>

      <div class="offer-right-spacer"></div>

      <button class="cta-btn" (click)="onUpgrade()">
        ✦ Upgrade to Pro Annual — ₹1,999/year →
      </button>
      <button class="maybe-later-btn" (click)="close()">Maybe later</button>
    </div>

  </ng-container>

  <!-- ========== MOBILE LAYOUT ========== -->
  <ng-container *ngIf="commonService.isMobileDisableClick">
    <div class="mobile-offer">

      <!-- Close -->
      <button class="close-btn" (click)="close()" aria-label="Close popup">
        <i class="pi pi-times"></i>
      </button>


      <!-- Hero image — compact -->
      <div class="mobile-hero">
        <img
          src="assets/imgs/offer_credit.webp"
          alt="Pro Annual"
          class="mobile-hero-img"
        />
      </div>

      <!-- Heading + Price -->
      <h2 class="offer-heading">
        Upgrade to <span class="heading-accent">Pro Annual</span>
      </h2>
      <div class="offer-price-row">
        <span class="offer-price">₹1,999</span>
        <span class="offer-price-sub">/ year</span>
        <div class="limited-badge">
          <!-- <span class="limited-icon">⚡</span> -->
          OFFER ENDS ON 31ST AUGUST
      </div>
      </div>

      <!-- Short description -->
      <!-- <p class="offer-desc mobile-desc">
        Sell unlimited beats &amp; sound kits with digital licensing, priority support &amp; lead generation tools — <strong>plus everything below.</strong>
      </p> -->

      <!--offer perks mobile-->
      <ul class="offer-perks py-1 pt-2">
        <li>
          <span class="perk-icon"><img src="assets/imgs/wallet.png" alt="Wallet" class="perk-icon-img" /></span>
          <span>
            <strong>Get ₹500 wallet ad credits For Free</strong> by 31st august to promote &amp; boost your
            beats across the platform
          </span>
        </li>
        <li>
          <span class="perk-icon"><img src="assets/imgs/golden-lightning.png" alt="Sound Kits" class="perk-icon-img" /></span>
          <span>
            <strong>Get 600 Sound Kit Credits</strong> — use it to grab sound kits, loops & drum kits from top industry-leading producers.
          </span>
        </li>
      </ul>
      <!-- Top 4 features only -->
      <div class="features-grid mobile-grid">
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Sell Unlimited Beats</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Sell Unlimited Sound Kits</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Digital Licensing</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>10% Commission</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>600 Kits Credits</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Campaigns at 20% Off</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Direct Bank Transfer</div>
        <div class="feature-item"><span class="feature-check"><i class="pi pi-check"></i></span>Lead Generation Access</div>
      </div>

      <!-- CTA -->
      <button class="cta-btn" (click)="onUpgrade()">
        ✦ Upgrade to Pro Annual →
      </button>
      <button class="maybe-later-btn" (click)="close()">Maybe later</button>

    </div>
  </ng-container>

</div>
